import { useEffect, useRef, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import Cookies from "js-cookie";
import { setLogout } from "../../redux/slices/signin-slice";

const deriveInitials = (name) => {
  if (!name) return "U";
  const parts = name.trim().split(/\s+/);
  const first = parts[0]?.[0] || "";
  const last = parts.length > 1 ? parts[parts.length - 1][0] : "";
  return (first + last).toUpperCase() || "U";
};

export default function ProfileDropdown() {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const { currentUser, userType } = useSelector(
    (state) => state.signinSliceReducer || {}
  );
  const fullName = currentUser || "User";
  const email = localStorage.getItem("currentUser") || "";
  const initials = deriveInitials(currentUser);
  const role = userType ? userType[0].toUpperCase() + userType.slice(1) : "Admin";

  useEffect(() => {
    if (!open) return;
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, [open]);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  const handleSignOut = () => {
    Cookies.remove("e_access_token");
    localStorage.clear();
    dispatch(setLogout());
    setOpen(false);
    window.location.href = "/signin";
  };

  const go = (path) => () => {
    setOpen(false);
    navigate(path);
  };

  return (
    <div className="relative" ref={ref}>
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        aria-label="Open user menu"
        aria-expanded={open}
        className="w-7 h-7 rounded-full bg-vf-primary text-white flex items-center justify-center text-xs font-semibold hover:ring-2 hover:ring-vf-primary/30 transition-all"
      >
        {initials}
      </button>

      {open && (
        <div className="absolute right-0 top-full mt-2 w-56 bg-white rounded-lg shadow-lg border border-slate-200 py-2 z-50">
          <div className="px-4 py-2 border-b border-slate-100">
            <div className="text-sm font-semibold text-vf-base truncate">{fullName}</div>
            <div className="text-xs text-vf-muted truncate">{role}</div>
          </div>
          <div className="py-1">
            <MenuItem label="My Account" onClick={go("/admin/my-account")} />
            <MenuItem label="Preferences" onClick={go("/admin/preferences")} />
            <MenuItem label="Settings" onClick={go("/admin/settings")} />
            <MenuItem label="Help & Support" onClick={go("/admin/help-support")} />
            <MenuItem
              label="Re-take product tour"
              onClick={() => {
                setOpen(false);
                try { localStorage.removeItem("ample_tour_completed"); } catch {}
                window.dispatchEvent(new CustomEvent("amplehire:start-tour"));
              }}
            />
          </div>
          <div className="border-t border-slate-100 py-1">
            <MenuItem label="Sign Out" onClick={handleSignOut} danger />
          </div>
        </div>
      )}
    </div>
  );
}

const MenuItem = ({ label, onClick, danger }) => (
  <button
    type="button"
    onClick={onClick}
    className={`w-full text-left px-4 py-2 text-sm hover:bg-vf-tint/40 ${
      danger ? "text-red-600" : "text-vf-base"
    }`}
  >
    {label}
  </button>
);
